import React from "react";
import { FundCalendar } from "@/types";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { CheckCircle } from "lucide-react";
import {
  useFundCalendarsListController,
  FundCalendarsListControllerProps,
} from "./useFundCalendarsListController";

type FundCalendarsListProps = FundCalendarsListControllerProps;

export default function FundCalendarsList(props: FundCalendarsListProps) {
  const controller = useFundCalendarsListController(props);

  if (controller.isLoading) {
    return (
      <Card>
        <CardContent className="p-4 ">
          <h3 className="font-medium mb-4">Fund Calendars</h3>
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex items-center mb-3 gap-2">
              <Skeleton className="h-4 w-full" />
            </div>
          ))}
        </CardContent>
      </Card>
    );
  }

  if (controller.calendars.length === 0) {
    return (
      <Card>
        <CardContent className="p-4">
          <h3 className="font-medium mb-2">Fund Calendars</h3>
          <p className="text-sm text-gray-500">No calendars found</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="p-4">
        <h3 className="font-medium mb-4">Fund Calendars</h3>
        <div className="space-y-2">
          {controller.calendars.map((calendar) => (
            <div
              key={calendar.fundCalendarId}
              className={`p-3 rounded-md cursor-pointer flex items-center justify-between ${
                controller.selectedCalendar?.fundCalendarId ===
                calendar.fundCalendarId
                  ? "bg-primary/10 border-primary"
                  : "hover:bg-gray-50 border-transparent"
              } border`}
              onClick={() => controller.handleSelect(calendar)}
            >
              <div>
                <div className="font-medium">{calendar.name}</div>
                {/* <div className="text-xs text-gray-500">
                  {calendar.intervalDefinition}
                </div> */}
              </div>
              {calendar.isDefault && (
                <CheckCircle size={16} className="text-green-500" />
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
